import type { InfraProcess } from '@/lib/types'

interface TopProcessesProps {
  processes: InfraProcess[]
}

export function TopProcesses({ processes }: TopProcessesProps): React.JSX.Element {
  if (processes.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-surface-3 p-6 text-center text-sm text-text-tertiary">
        No process data available
      </p>
    )
  }

  return (
    <div className="overflow-hidden rounded-xl border border-surface-3 bg-surface-0">
      <table className="w-full text-left text-sm">
        <thead className="border-b border-surface-3 bg-surface-1">
          <tr>
            <th className="px-4 py-3 font-medium text-text-secondary">PID</th>
            <th className="px-4 py-3 font-medium text-text-secondary">Name</th>
            <th className="px-4 py-3 font-medium text-text-secondary">CPU %</th>
            <th className="px-4 py-3 font-medium text-text-secondary">Memory</th>
            <th className="px-4 py-3 font-medium text-text-secondary">State</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-surface-3">
          {processes.map((p) => (
            <tr key={p.pid}>
              <td className="px-4 py-2 font-mono text-xs text-text-secondary">{p.pid}</td>
              <td className="px-4 py-2 font-medium text-text-primary">{p.name}</td>
              <td className="px-4 py-2 text-text-primary">{p.cpu_percent.toFixed(1)}%</td>
              <td className="px-4 py-2 text-text-primary">{p.memory_mb.toFixed(1)} MB</td>
              <td className="px-4 py-2">
                <span className="rounded bg-surface-2 px-2 py-0.5 text-xs text-text-secondary">
                  {p.state}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
